if (!customElements.get('collection-card-gallery')) {
  class CollectionCardGallery extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.pointerStartX = null;
      this.didDrag = false;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      this.previousButton = this.querySelector('[data-gallery-previous]');
      this.nextButton = this.querySelector('[data-gallery-next]');
      if (!this.track) return;
      this.classList.add('is-enabled');

      this.track.addEventListener('pointerdown', (event) => {
        this.pointerStartX = event.clientX;
        this.didDrag = false;
      });
      this.track.addEventListener('pointermove', (event) => {
        if (this.pointerStartX !== null && Math.abs(event.clientX - this.pointerStartX) > 8) this.didDrag = true;
      });
      this.track.addEventListener('pointerup', () => { this.pointerStartX = null; });
      this.track.addEventListener('pointercancel', () => { this.pointerStartX = null; });
      this.track.addEventListener('click', (event) => this.openProduct(event));
      if (this.slides.length < 2) return;

      this.previousButton?.addEventListener('click', (event) => this.move(event, -1));
      this.nextButton?.addEventListener('click', (event) => this.move(event, 1));
      this.track.addEventListener('scroll', () => this.updateActiveSlide(), { passive: true });
      this.updateControls();
    }

    move(event, direction) {
      event.preventDefault();
      event.stopPropagation();
      const nextIndex = Math.max(0, Math.min(this.slides.length - 1, this.activeIndex + direction));
      this.track.scrollTo({ left: nextIndex * this.track.clientWidth, behavior: 'smooth' });
    }

    updateActiveSlide() {
      const slideWidth = this.track.clientWidth;
      if (!slideWidth) return;
      const nextIndex = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / slideWidth)));
      if (nextIndex === this.activeIndex) return;
      this.activeIndex = nextIndex;
      this.updateControls();
    }

    updateControls() {
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.activeIndex));
      if (this.previousButton) this.previousButton.disabled = this.activeIndex === 0;
      if (this.nextButton) this.nextButton.disabled = this.activeIndex === this.slides.length - 1;
    }

    openProduct(event) {
      if (this.didDrag) {
        event.preventDefault();
        this.didDrag = false;
        return;
      }
      if (this.dataset.productUrl) window.location.href = this.dataset.productUrl;
    }
  }

  customElements.define('collection-card-gallery', CollectionCardGallery);
}
